import { render } from "./BusinessModel.vue?vue&type=template&id=0b625d91&scoped=true"
import script from "./BusinessModel.vue?vue&type=script&lang=js"
export * from "./BusinessModel.vue?vue&type=script&lang=js"

import "./BusinessModel.vue?vue&type=style&index=0&id=0b625d91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b625d91"]])

export default __exports__